import React from 'react';
import { Link } from 'react-router-dom';

const formatDate = (timestamp) => {

  const date = timestamp.toDate();
  return date.toLocaleDateString('da-DK', {
    year: 'numeric', 
    month: 'long', 
    day: 'numeric'
  });
};

const WorkerCasesList = ({ workerCases, renderRatingsAndQuestions }) => {
  return (
    <ul className='worker-details-list'>
      {workerCases.map((c) => (
        <li key={c.id} className={`case-item ${c.archived ? 'archived-case' : ''}`}>
          <h3 className='case-title'>
            Sag Nr: {c.appointmentNumber} Dato: {formatDate(c.timestamp)}
            {c.archived && <span className="archived-indicator">Arkiveret</span>}
          </h3>
          {renderRatingsAndQuestions(c.ratings, c.questionsAnswered)}
          <Link to={c.archived ? `/valuator/archived-cases/${c.id}` : `/valuator/cases/${c.id}`} className="case-details-link">
            Se sags detaljer
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default WorkerCasesList;
